import axios from "axios";

export default class Kithara {
  getHTTP() {
    return axios.create({
      baseURL: "api",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("kithara.token")
      }
    });
  }

  login(username, password) {
    return this.getHTTP().post(`/v1/auth`, {
      username,
      password
    });
  }

  getSongs(page, perPage, sort, filters) {
    const tags = filters.tags.join("+");
    return this.getHTTP().get("/v2/song-versions", {
      params: {
        page: page,
        per_page: perPage,
        sort: sort,
        filter: filters.main,
        tags: tags
      }
    });
  }

  getTeamSongs(team, page, perPage, sort, filters) {
    const tags = filters.tags.join("+");
    return this.getHTTP().get(`/v2/teams/${team}/song-versions`, {
      params: {
        page: page,
        per_page: perPage,
        sort: sort,
        filter: filters.main,
        tags: tags
      }
    });
  }

  getSong(id) {
    return this.getHTTP().get(`/v2/song-versions/${id}`);
  }

  createSong(data) {
    // fill with the default translator, languate and song.composer.
    // name field is not used by the API but required for the moment.
    const tags = data.song && data.song.tags ? data.song.tags : [];
    data["translator"] = { id: 1, name: "whatever" };
    data["language"] = { id: 1, name: "whatever" };
    data["song"] = {
      composer: { id: 1, name: "whatever" },
      tags: tags
    };
    return this.getHTTP().post(`/v2/song-versions`, data);
  }

  updateSong(id, data) {
    return this.getHTTP().put(`/v2/song-versions/${id}`, data);
  }

  deleteSong(id) {
    return this.getHTTP().delete(`/v2/song-versions/${id}`);
  }

  getPlaylists(page, perPage, sort, filter) {
    return this.getHTTP().get("/v2/playlists", {
      params: {
        page: page,
        per_page: perPage,
        sort: sort,
        filter: filter
      }
    });
  }

  getPlaylist(id) {
    return this.getHTTP().get(`/v2/playlists/${id}`);
  }

  createPlaylist(data) {
    return this.getHTTP().post(`/v2/playlists`, data);
  }

  updatePlaylist(id, data) {
    return this.getHTTP().put(`/v2/playlists/${id}`, data);
  }

  deletePlaylist(id) {
    return this.getHTTP().delete(`/v2/playlists/${id}`);
  }

  getPlaylistItems(playlistId, page, perPage, sort, filter) {
    return this.getHTTP().get(`/v2/playlists/${playlistId}/items`, {
      params: {
        page: page,
        per_page: perPage,
        sort: sort,
        filter: filter
      }
    });
  }

  getPlaylistItem(playlistId, itemId) {
    return this.getHTTP().get(`/v2/playlists/${playlistId}/items/${itemId}`);
  }

  updatePlaylistItems(playlistId, data) {
    return this.getHTTP().put(`/v2/playlists/${playlistId}/items`, data);
  }

  download(playlistId) {
    if (playlistId) {
      return this.getHTTP().get(
        `/v2/playlists/${playlistId}/export?download=`,
        {
          responseType: "blob"
        }
      );
    } else {
      return this.getHTTP().get(`/v1/export?download=`, {
        responseType: "blob"
      });
    }
  }

  getTags() {
    return this.getHTTP().get("/v2/tags");
  }

  getTag(id) {
    return this.getHTTP().get(`v2/tags/${id}`);
  }

  postTag(tag) {
    return this.getHTTP().post("v2/tags/", tag);
  }

  getUserKnowledge(userID, songID) {
    return this.getHTTP().get(`/v2/users/${userID}/song-versions/${songID}/knowledge`);
  }

  setUserKnowledge(userID, songID, value) {
    return this.getHTTP().put(`/v2/users/${userID}/song-versions/${songID}/knowledge`, value, {
        headers: {
            'Content-Type': 'text/plain',
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/kithara.js